<script>
import { updateOneSelfCheckIn } from '@/services/SelfCheckInServices';
import { nextTick } from 'vue';

export default {
  props: [ 'propSelfCheckIn' ],
  emits: [ 'scrollToTasks' ],
  data() {
    return {
      // selfCheckIn object (from dbase)
      selfCheckIn: null,
      // inputs (from form)
      feelingToday: '',
      grateful1: '',
      grateful2: '',
      grateful3: '',
      myIntentions: '',

      showAlertSaveAllChanges: false,
    };
  },
  computed: {
    uId() { return this.$store.getters['uId']; },
    token() { return this.$store.getters['token']; },
    today() { return this.$store.getters['today']; },
    todayActual() { return this.$store.getters['todayActual']; },
  },
  methods: {
    async updateSelfCheckIn() {
      let updatedCheckIn = {
        feeling: this.feelingToday.trim().length ? this.feelingToday.trim() : this.selfCheckIn.feeling,
        grateful1: this.grateful1.trim().length ? this.grateful1.trim() : this.selfCheckIn.grateful1,
        grateful2: this.grateful2.trim().length ? this.grateful2.trim() : this.selfCheckIn.grateful2,
        grateful3: this.grateful3.trim().length ? this.grateful3.trim() : this.selfCheckIn.grateful3,
        intentions: this.myIntentions.trim().length ? this.myIntentions.trim() : this.selfCheckIn.intentions,

        dateCreated: this.selfCheckIn.dateCreated ? this.selfCheckIn.dateCreated : this.todayActual,
        dateUpdated: this.todayActual,
      };

      const checkInWasUpdated = await updateOneSelfCheckIn(this.uId, this.token, this.today, updatedCheckIn);
      if (checkInWasUpdated) {
        this.selfCheckIn = { ...updatedCheckIn };
      }
    },

    async editFeelingToday() {
      this.feelingToday = this.selfCheckIn.feeling;
      this.selfCheckIn.feeling = '';
      await nextTick();
      const f = document.getElementById('input-feeling-today');
      if (f) {
        f.click();
      }
    },
    async editGratefulFor() {
      this.grateful1 = this.selfCheckIn.grateful1;
      this.grateful2 = this.selfCheckIn.grateful2;
      this.grateful3 = this.selfCheckIn.grateful3;

      this.selfCheckIn.grateful1 = this.selfCheckIn.grateful2 = this.selfCheckIn.grateful3 = '';
      await nextTick();
      const gr = this.grateful2.length ? '3' : this.grateful1.length ? '2' : '1';
      const f = document.getElementById(`input-grateful-${gr}`);
      if (f) {
        f.click();
      }
    },
    async editMyIntentions() {
      this.myIntentions = this.selfCheckIn.intentions;
      this.selfCheckIn.intentions = '';
      await nextTick();
      const f = document.getElementById('input-my-intentions');
      if (f) {
        f.click();
      }
    },

    scrollToAddTasks() {
      this.showAlertSaveAllChanges = false;
      this.$emit('scrollToTasks');
    },
  },
  async created() {
    // if morning check-in DOES NOT already exist
    if (!this.propSelfCheckIn) {
      this.selfCheckIn = {
        feeling: '',
        grateful1: '',
        grateful2: '',
        grateful3: '',
        intentions: '',
        dateUpdated: this.todayActual,
        dateCreated: this.todayActual,
      };
    }
    else { // if morning check-in DOES already exist
      this.selfCheckIn = { ...this.propSelfCheckIn };

      this.feelingToday = this.selfCheckIn.feeling;

      this.grateful1 = this.selfCheckIn.grateful1;
      this.grateful2 = this.selfCheckIn.grateful2;
      this.grateful3 = this.selfCheckIn.grateful3;
      if (this.selfCheckIn.grateful && !this.selfCheckIn.grateful1) { // deal with old version .grateful
        this.grateful1 = this.selfCheckIn.grateful1 = this.selfCheckIn.grateful;
      }

      this.myIntentions = this.selfCheckIn.intentions;
    }
  },
}
</script>
<template>
<!--    SAVE ALL CHANGES BEFORE PROCEEDING. Unsaved changes will be lost.-->


  <div id="checkin-feeling-today" class="mt-5">
    <p class="mb-2">
      <b>What are you feeling today? How are you doing, my love?</b><br />
      <span class="text-body-2 text-grey-darken-1 font-italic">(<a href="https://imgur.com/FJC4dX1" class="text-grey-darken-1" target="_blank" rel="noopener noreferrer">link to Emotion Wheel</a>)</span>
    </p>
    <div v-if="selfCheckIn.feeling">
      <ul class="ml-3"><li class="dashboard-pre-line">{{ selfCheckIn.feeling }}</li></ul>
      <p class="text-right text-red-lighten-2 text-body-2 font-italic">
        <span @click.prevent="editFeelingToday" class="edit-check-in-btn ">Edit</span>
      </p>
    </div>
    <div v-else>
      <v-textarea v-model="feelingToday" id="input-feeling-today"
                  variant="outlined"
                  rows="3" auto-grow
                  label="What are you feeling today?"
      ></v-textarea>
      <div class="checkin-save-button-wrapper d-flex justify-end">
        <v-btn @click.prevent="updateSelfCheckIn"
               density="compact"
               :class="feelingToday.trim() ? 'bg-green-lighten-3' : ''"
               class="text-capitalize px-0"
               :disabled="!feelingToday.trim()"
        >Save</v-btn>
      </div>
    </div>

  </div>


  <div id="checkin-grateful-for" class="mt-8">
    <p class="mb-2">
      <b>What are you grateful for? (3+ people / places / experiences)</b>. <span class="text-body-2 text-grey-darken-1">Focus on what you <i>do</i> have, who you <i>already</i> are.</span>
    </p>
    <div v-if="selfCheckIn.grateful1">
      <ul class="ml-3">
        <li class="dashboard-pre-line">{{ selfCheckIn.grateful1 }}</li>
        <li v-if="selfCheckIn.grateful2" class="dashboard-pre-line">{{ selfCheckIn.grateful2 }}</li>
        <li v-if="selfCheckIn.grateful3" class="dashboard-pre-line">{{ selfCheckIn.grateful3 }}</li>
      </ul>
      <p class="text-right text-red-lighten-2 text-body-2 font-italic">
        <span @click.prevent="editGratefulFor" class="edit-check-in-btn">Edit</span>
      </p>
    </div>
    <div v-else>
      <v-textarea v-model="grateful1" id="input-grateful-1"
                  variant="outlined"
                  rows="1" auto-grow
                  label="What are you grateful for?"
      ></v-textarea>
      <v-textarea v-if="grateful1.length" v-model="grateful2"
                  id="input-grateful-2"
                  variant="outlined"
                  rows="1" auto-grow
                  label="What are you grateful for?"
      ></v-textarea>
      <v-textarea v-if="grateful2.length" v-model="grateful3"
                  id="input-grateful-3"
                  variant="outlined"
                  rows="1" auto-grow
                  label="What are you grateful for?"
      ></v-textarea>
      <div class="checkin-save-button-wrapper d-flex justify-end">
        <v-btn @click.prevent="updateSelfCheckIn"
               density="compact"
               class="text-capitalize px-0"
               :class="grateful1.trim() ? 'bg-green-lighten-3' : ''"
               :disabled="!grateful1.trim()"
        >Save</v-btn>
      </div>
    </div>
  </div>


  <div id="checkin-my-intentions" class="mt-8">
    <p class="mb-2">
      <b>My intentions for today... </b>

      <span class="text-body-2 text-grey-darken-1">What kind of Man I am. What I expect to happen VS what could happen — and how I behave/conduct myself when the challenges come.</span>
    </p>
    <div v-if="selfCheckIn.intentions">
      <ul class="ml-3"><li class="dashboard-pre-line">{{ selfCheckIn.intentions }}</li></ul>
      <p class="text-right text-red-lighten-2 text-body-2 font-italic">
        <span @click.prevent="editMyIntentions" class="edit-check-in-btn">Edit</span>
      </p>
    </div>
    <div v-else>
      <v-textarea v-model="myIntentions" id="input-my-intentions"
                  variant="outlined"
                  rows="3" auto-grow
                  label="My intentions for today are..."
      ></v-textarea>
      <div class="checkin-save-button-wrapper d-flex justify-end">
        <v-btn @click.prevent="updateSelfCheckIn"
               density="compact"
               class="text-capitalize px-0"
               :class="myIntentions.trim() ? 'bg-green-lighten-3' : ''"
               :disabled="!myIntentions.trim()"
        >Save</v-btn>
      </div>
    </div>
  </div>


  <div class="mt-8">
    <p>
      <b>Tasks I need to do are… </b><br />
      <span class="text-body-2 text-grey-darken-1"> 1 Big Task, and 3-5 smaller tasks</span>
    </p>
    <div class="mt-3 text-right">
      <v-btn class="text-capitalize font-italic" color="grey-darken-2" variant="outlined" @click.prevent="showAlertSaveAllChanges = true">Add tasks to today's list</v-btn>
    </div>
    <v-dialog
      v-model="showAlertSaveAllChanges"
      width="auto"
    >
      <v-card
        title="SAVE BEFORE PROCEEDING"
        text="Unsaved changes will be lost."
      >
        <template v-slot:actions>
          <div class="w-100 d-flex justify-space-around">
            <v-btn
              color="red"
              @click.prevent="showAlertSaveAllChanges = false"
            >Go Back</v-btn>
            <v-btn
              color="green"
              @click.prevent="scrollToAddTasks"
            >Add Tasks</v-btn>
          </div>
        </template>
      </v-card>
    </v-dialog>
  </div>

</template>
<style lang="scss" scoped>
.dashboard-pre-line { white-space: pre-line; }
p {
  line-height: 1.2rem;
}
.checkin-save-button-wrapper  { margin-top: -16px; }
.edit-check-in-btn {
  &:hover { cursor: pointer; }
}
</style>
